<template>
	<div class="flex align-items progressbar-wrapper">
		<div class="progressbar">
			<div class="bar" :style="'width: ' + percentage + '%'">
				<div class="indicator">{{ progress }}</div>
			</div>
		</div>
		<div class="total">/ {{ total }}</div>
	</div>
</template>

<script>
export default {
  props: [
    'progress',
    'total'
  ],
  computed: {
    percentage () {
      return Math.round(100 * this.progress / this.total)
    }
  }
}
</script>

<style lang="less">
	@border-radius: 3px;
	@bar-color: #73aec7;
	.progressbar-wrapper {
		position: relative;
		width: fit-content;
		&::after {
			position: absolute;
			top: 0px;
			left: 0px;
			right: 0px;
			bottom: 0px;
			border: 1px solid rgba(0, 0, 0, 0.2);
			border-radius: @border-radius;
			content: "";
		}
	}
	.total {
		border-left: none;
		background: linear-gradient(180deg, #444, #222);
		color: #fff;
		width: 54px;
		height: 24px;
		font-size: 12px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-top-right-radius: @border-radius;
		border-bottom-right-radius: @border-radius;
	}
	.progressbar {
		width: 130px;
		height: 24px;
		position: relative;
		border-top-left-radius: @border-radius;
		border-bottom-left-radius: @border-radius;
		overflow: hidden;
		.bar {
			position: absolute;
			top: 0px;
			left: 0px;
			bottom: 0px;
			background: linear-gradient(180deg, lighten(@bar-color, 10%), lighten(@bar-color, -10%));
			.indicator {
				position: absolute;
				top: 0px;
				left: 0px;
				bottom: 0px;
				right: 0px;
				display: flex;
				align-items: center;
				justify-content: flex-end;
				// position: absolute;
				// text-align: right;
				margin-right: 6px;
				font-size: 12px;
				font-weight: 900;
			}
		}
	}
</style>
